import { render, staticRenderFns } from "./EditDrugOrga.vue?vue&type=template&id=76dd3149&scoped=true"
import script from "./EditDrugOrga.vue?vue&type=script&lang=js"
export * from "./EditDrugOrga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd3149",
  null
  
)

export default component.exports